// Recent store searches (owner, 2026-10-25: «سجل البحث»). Per browser only:
// kept in localStorage and never sent anywhere. The app keeps the same list
// under the same key (src/lib/market/marketSearchHistory.js in -maabar-app).
// Never throws — a storage failure costs the list, never a search.
const KEY = 'maabar.market.searches';
export const SEARCH_HISTORY_MAX = 8;

const clean = (v) => (Array.isArray(v) ? v.filter((x) => typeof x === 'string' && x.trim()).slice(0, SEARCH_HISTORY_MAX) : []);

export function loadSearches() {
  try { return clean(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch { return []; }
}

/** Puts `q` first (a repeat moves up instead of appearing twice) and returns the new list. */
export function rememberSearch(q) {
  const term = String(q || '').trim().slice(0, 80);
  if (!term) return loadSearches();
  const next = [term, ...loadSearches().filter((x) => x.toLowerCase() !== term.toLowerCase())].slice(0, SEARCH_HISTORY_MAX);
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* private mode: no history */ }
  return next;
}

export function clearSearches() {
  try { localStorage.removeItem(KEY); } catch { /* nothing to clear */ }
}
